module.exports = __webpack_public_path__ + "static/media/ic-regulations-active.6e9dca65.svg";